export const customSelect = () => {
   const customSelects = document.getElementsByClassName("custom-select");
   const customSelectsLength = customSelects.length;

   for (let i = 0; i < customSelectsLength; i++) {
      const selectElement =
         customSelects[i].getElementsByTagName("select")[0];
      const selectOptionsLength = selectElement.length;

      const selectedDiv = document.createElement("DIV");
      selectedDiv.setAttribute("class", "select-selected");
      selectedDiv.innerHTML =
         selectElement.options[selectElement.selectedIndex].innerHTML;
      customSelects[i].appendChild(selectedDiv);

      const optionsDiv = document.createElement("DIV");
      optionsDiv.setAttribute("class", "select-items select-hide");

      for (let j = 1; j < selectOptionsLength; j++) {
         const optionDiv = document.createElement("DIV");
         optionDiv.innerHTML = selectElement.options[j].innerHTML;

         optionDiv.addEventListener("click", function (e) {
            const currentSelect =
               this.parentNode.parentNode.getElementsByTagName(
                  "select"
               )[0];
            let selectOptionsLength, selectedOption, sameSelectedOptions;

            selectOptionsLength = currentSelect.length;
            selectedOption = this.parentNode.previousSibling;

            for (let k = 0; k < selectOptionsLength; k++) {
               if (currentSelect.options[k].innerHTML == this.innerHTML) {
                  currentSelect.selectedIndex = k;
                  selectedOption.innerHTML = this.innerHTML;
                  sameSelectedOptions =
                     this.parentNode.getElementsByClassName(
                        "same-as-selected"
                     );

                  for (let m = 0; m < sameSelectedOptions.length; m++) {
                     sameSelectedOptions[m].removeAttribute("class");
                  }

                  this.setAttribute("class", "same-as-selected");
                  break;
               }
            }

            selectedOption.click();
         });

         optionsDiv.appendChild(optionDiv);
      }

      customSelects[i].appendChild(optionsDiv);

      selectedDiv.addEventListener("click", function (e) {
         e.stopPropagation();
         closeAllSelect(this);
         this.nextSibling.classList.toggle("select-hide");
         this.classList.toggle("select-arrow-active");
      });
   }

   function closeAllSelect(elmnt) {
      const selectItems = document.getElementsByClassName("select-items");
      const selectSelected =
         document.getElementsByClassName("select-selected");

      for (let i = 0; i < selectSelected.length; i++) {
         if (elmnt == selectSelected[i]) {
            continue;
         } else {
            selectSelected[i].classList.remove("select-arrow-active");
         }
      }

      for (let j = 0; j < selectItems.length; j++) {
         if (selectSelected[j] == elmnt) {
            continue;
         } else {
            selectItems[j].classList.add("select-hide");
         }
      }
   }

   document.addEventListener("click", closeAllSelect);
};
